<template>
    <div>
        <!-- GUEST / ACCOUNTANT mặc định xem Dashboard -->
        <GuestDashboard
            v-if="IsDashboardUser"
        />

        <!-- USER / MANAGER mặc định xem EntryIndex -->
        <EntryIndex
            v-else-if="IsCRMUser"
        />

        <div v-else>
            Không xác định quyền truy cập.
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

import GuestDashboard from "./DashBoard.vue";
import EntryIndex from "./Entry/EntryIndex.vue";

export default {
    name: "Home",

    components: {
        GuestDashboard,
        EntryIndex
    },

    computed: {
        ...mapState([
            "oUser"
        ]),

        Role() {
            return String(
                this.oUser?.Role || ""
            ).toUpperCase();
        },

        IsAccountant() {
            return this.Role.includes("ACCOUNTANT");
        },

        IsManager() {
            return this.Role.includes("MANAGER");
        },

        IsGuest() {
            return this.Role.includes("GUEST");
        },

        IsUser() {
            return this.Role.includes("USER");
        },

        IsDashboardUser() {
            return (
                this.IsGuest ||
                this.IsAccountant
            );
        },

        IsCRMUser() {
            return (
                this.IsUser ||
                this.IsManager
            );
        }
    }
};
</script>